import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { ConceptoFacturacion } from '../../_models/concepto-facturacion';
import { ConceptoFacturacionService } from '../../_services/concepto-facturacion.service';
import {Conceptos} from '../../_enums/enum';

@Component( {
  selector: 'app-concepto-facturacion-editar',
  templateUrl: 'concepto-facturacion-editar.component.html'
} )

export class ConceptoFacturacionEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  concepto: ConceptoFacturacion;
  lisConceptos: ConceptoFacturacion[] = [];
  formulario: FormGroup;
  submitted = false;
  codigosConceptos = Conceptos;
  constructor( private conFacturacionServicio: ConceptoFacturacionService,
               private route: ActivatedRoute,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private navServicio: NavService ) {
  }

  ngOnInit(): void {

    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.conFacturacionServicio.obtenerPorId( params[ 'id' ] ).subscribe( concepto => {
          this.concepto = concepto;
          this.carServiciosIniciales();
        } );
      } else {
        this.carServiciosIniciales();
      }
    } );
  }

  carServiciosIniciales() {
    this.formulario = this.fb.group( {
      idConceptoFacturacion: [ this.concepto ? this.concepto.idConceptoFacturacion : null ],
      codigo: [ this.concepto ? this.concepto.codigo : null, [ Validators.required, Validators.maxLength( 10 ) ] ],
      nombre: [ this.concepto ? this.concepto.nombre : null, [ Validators.required, Validators.maxLength( 50 ) ] ],
      indicadorHabilitado: [ this.concepto ? this.concepto.indicadorHabilitado : true ],
      indicadorAnalizamos: [ this.concepto ? this.concepto.indicadorAnalizamos : false ],
      indicadorDinero: [ this.concepto ? this.concepto.indicadorDinero : false ],
      indicadorRedondear: [ this.concepto ? this.concepto.indicadorRedondear : false ],
      indicadorSuma: [ this.concepto ? this.concepto.indicadorSuma : null, [ Validators.required ] ],
      indicadorAnual: [ this.concepto ? this.concepto.indicadorAnual : false ],
      auditoriaUsuario: [ this.concepto ? this.concepto.auditoriaUsuario : null ],
      auditoriaFecha: [ this.concepto ? this.concepto.auditoriaFecha : null ],
      indicadorRango: [ this.concepto ? this.concepto.indicadorRango : false, [ Validators.required ] ],
      descripcion: [ this.concepto ? this.concepto.descripcion : null, [ Validators.required ] ]
    } );

    this.conFacturacionServicio.listado().subscribe( conceptos => {
      this.lisConceptos = conceptos;
      this.carInformacionInicial = false;
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      const conRedondear = this.lisConceptos.find( x => x.indicadorRedondear && this.f.idConceptoFacturacion.value !== x.idConceptoFacturacion && x.indicadorHabilitado );
      if ( this.f.indicadorRedondear.value && conRedondear ) {
        this.conServicio.confirm( {
          message: this.navServicio.buscarMensaje( 'CONCEPTOS.MSG_EXISTEREDONDEAR' ),
          header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
          icon: 'fa fa-question-circle',
          accept: () => {
            this.guardarConcepto( conRedondear );
          },
          reject: () => {
            this.guardando = false;
          }
        } );
      } else {
        this.guardarConcepto();
      }
    }
  }

  guardarConcepto( conRedondear?: ConceptoFacturacion ) {
    const concepto = this.formulario.getRawValue();
    if ( concepto && concepto.idConceptoFacturacion ) {
      this.conFacturacionServicio.actualizar( concepto ).subscribe( rta => {
        if ( conRedondear ) {
          conRedondear.indicadorRedondear = false;
          this.conFacturacionServicio.actualizar( conRedondear ).subscribe( actConcepto => {
            this.navServicio.setMesage( 2 );
            this.guardando = false;
            this.location.back();
          } );
        } else {
          this.navServicio.setMesage( 2 );
          this.guardando = false;
          this.location.back();
        }
      }, error => {
        this.navServicio.setMesage( 3 );
        this.guardando = false;
      } );
    } else {
      this.conFacturacionServicio.crear( concepto ).subscribe( rta => {
        concepto.idConceptoFacturacion = rta.idConceptoFacturacion;
        this.f.idConceptoFacturacion.setValue( rta.idConceptoFacturacion );
        if ( conRedondear ) {
          conRedondear.indicadorRedondear = false;
          this.conFacturacionServicio.actualizar( conRedondear ).subscribe( actConcepto => {
            this.navServicio.setMesage( 1 );
            this.guardando = false;
            this.location.back();
          } );
        } else {
          this.navServicio.setMesage( 1 );
          this.guardando = false;
          this.location.back();
        }
      }, error => {
        this.navServicio.setMesage( 3 );
        this.guardando = false;
      } );
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  validarCodigo() {
    this.codExiste = this.lisConceptos.find( x => x.codigo === this.f.codigo.value ) ? true : false;
    if(!this.codExiste && (this.f.codigo.value === Conceptos.RECCRE || this.f.codigo.value === Conceptos.SEGDES) ) {
      this.f.indicadorSuma.setValue(false);
    }
  }

  get f() {
    return this.formulario.controls;
  }

  cambioDinero( checked: boolean ) {
    if ( !checked ) {
      this.f.indicadorRedondear.setValue( false );
    }
  }

}
